import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import Lobby from 'app/Components/Shared/Lobby';
import ExtendedProductPageData from 'Models/Content/ExtendedProductPageData';
import {isMobile} from 'react-device-detect';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import TagName from 'app/Components/Shared/TagName';
import HeadButton from '../TVContentsPage/HeadButton';

export default class ExtendedProductPage extends Page<ExtendedProductPageData> {
  render() {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    const {
      data: {
        title,
        subtitle,
        desktopTitle,
        desktopSubtitle,
        mobileBackgroundImage,
        backgroundImage,
        mainContentArea,
        titleHeadlineTag,
        subtitleHeadlineTag,
        headerButtonLink,
        isShowHeaderButton,
        blockButton,
      },
      context,
    } = this.props;

    const backGroundWeb = backgroundImage.value;
    const backGroundMobile = mobileBackgroundImage.value;

    const func = () => {
      if (isMobile) {
        if (backGroundMobile == null) {
          return false;
        }
        return true;
      } else if (!isMobile) {
        if (backGroundWeb == null) {
          return false;
        }
        return true;
      }
      return false;
    };

    const flg = func();

    return (
      <div className='ExtendedProductPage'>
        {flg ? (
          <>
            <div className='ExtendedProductPage__head'>
              <TagName className='ExtendedProductPage__head__title' tagName={titleHeadlineTag?.value} isTitle>
                {!isMobile && desktopTitle?.expandedValue
                  ? (desktopTitle?.expandedValue[0] as MarketingTextBlockData).text.value
                  : title.value}
              </TagName>
              <TagName className='ExtendedProductPage__head__subtitle' tagName={subtitleHeadlineTag?.value}>
                {!isMobile && desktopSubtitle?.value ? desktopSubtitle.value : subtitle.value}
              </TagName>
              <div
                className='ExtendedProductPage__image'
                {...getBackgroundImageProps(isMobile ? mobileBackgroundImage : backgroundImage, context)}
              />
            </div>
          </>
        ) : (
          <>
            <div className='ExtendedProductPage__headWithoutImage'>
              <TagName className='ExtendedProductPage__head__title' tagName={titleHeadlineTag?.value} isTitle>
                {!isMobile && desktopTitle?.expandedValue
                  ? (desktopTitle?.expandedValue[0] as MarketingTextBlockData).text.value
                  : title.value}
              </TagName>
              <TagName className='ExtendedProductPage__head__subtitle' tagName={subtitleHeadlineTag?.value}>
                {!isMobile && desktopSubtitle?.value ? desktopSubtitle.value : subtitle.value}
              </TagName>
              <div
                className='ExtendedProductPage__image'
                {...getBackgroundImageProps(isMobile ? mobileBackgroundImage : backgroundImage, context)}
              />
            </div>
          </>
        )}

        <div>
          <HeadButton blockButton={blockButton} isShowHeaderButton={isShowHeaderButton} headerButtonLink={headerButtonLink}></HeadButton>
        </div>
        <ContentArea noWrap data={mainContentArea} context={context} />
      </div>
    );
  }
}
